export enum BusinessPoliciesTestIds {
  CREATE_BUTTON = 'business-policies-create-button',
  COPY_ACTION = 'business-policies-copy-action',
  DELETE_ACTION = 'business-policies-delete-action',
  DELETE_CONFIRM_BUTTON = 'business-policies-delete-confirm-button',
  MASS_ACTIONS_BAR = 'business-policies-mass-actions-bar',
  FORM_NAME_INPUT = 'business-policies-form-name-input',
  FORM_SAVE_BUTTON = 'business-policies-form-save-button',
  FORM_TYPE_SELECT = 'business-policies-form-type-select',
  FORM_ACTIVE_CHECKBOX = 'business-policies-form-active-checkbox',
  FORM_CREATE_SIMPLE_CRITERIA_BUTTON = 'business-policies-form-create-simple-criteria-button',
  FORM_CRITERIA_VALUE_INPUT = 'business-policies-form-criteria-value-input',
  FORM_DISCOUNT_VALUE_INPUT = 'business-policies-form-discount-value-input',
  FORM_CUMULATIVE_SELECT = 'business-policies-form-cumulative-select',
  FORM_DISCOUNT_TYPE_SELECT = 'business-policies-form-discount-type-select',
  FORM_INTEGRATION_CODE_INPUT = 'business-policy-form-integration-code-field',
  FORM_FOR_WHOM_LOGICAL_OPERATOR_SELECT = 'business-policies-form-for-whom-logical-operator-select',
  FORM_CUSTOMER_CLASSIFICATION_OPERATOR_SELECT = 'business-policies-form-customer-classification-operator-select',
  FORM_CUSTOMER_CLASSIFICATION_AUTOCOMPLETE = 'business-policies-form-customer-classification-autocomplete',
  FORM_CUSTOMER_STATE_OPERATOR_SELECT = 'business-policies-form-customer-state-operator-select',
  FORM_CUSTOMER_STATE_AUTOCOMPLETE = 'business-policies-form-customer-state-autocomplete',
  FORM_READ_ONLY_ALERT = 'business-policies-form-read-only-alert',
  FORM_CREATE_COMPARATIVE_CRITERIA_BUTTON = 'business-policies-form-create-comparative-criteria-button',
  FORM_CRITERIA_TYPE_SELECT = 'business-policies-form-criteria-type-select',
  FORM_CRITERIA_OPERATOR_SELECT = 'business-policies-form-criteria-operator-select',
  FORM_COMPARATIVE_LEFT_TYPE_SELECT = 'business-policies-form-comparative-left-type-select',
  FORM_COMPARATIVE_RIGHT_TYPE_SELECT = 'business-policies-form-comparative-right-type-select',
  FORM_COMPARATIVE_FACTOR_INPUT = 'business-policies-form-comparative-factor-input',
  FORM_ADD_REWARD_BUTTON = 'business-policies-form-add-reward-button',
  FORM_REWARD_ITEM = 'business-policies-form-reward-item',
  FORM_REMOVE_REWARD_BUTTON = 'business-policies-form-remove-reward-button',
  FORM_ADD_RANGE_BUTTON = 'business-policies-form-add-range-button',
  FORM_REMOVE_RANGE_BUTTON = 'business-policies-form-remove-range-button',
  FORM_ADVANCED_MODE_SWITCH = 'business-policies-form-advanced-mode-switch',
  FORM_COPY_CRITERIA_BUTTON = 'business-policies-form-copy-criteria-button',
  FORM_PASTE_CRITERIA_BUTTON = 'business-policies-form-paste-criteria-button',
  FORM_REMOVE_CRITERIA_BUTTON = 'business-policies-form-remove-criteria-button',
  FORM_CRITERIA_GROUP = 'business-policies-form-criteria-group',
  FORM_ADD_ADDITIVE_CRITERIA_BUTTON = 'business-policies-form-add-additive-criteria-button',
  FORM_ADD_ALTERNATIVE_CRITERIA_BUTTON = 'business-policies-form-add-alternative-criteria-button',
  FORM_REMOVE_CRITERIA_ROW_BUTTON = 'business-policies-form-remove-criteria-row-button',
  FORM_ADD_SIMPLE_CRITERIA_OPTION = 'business-policies-form-add-simple-criteria-option',
  FORM_ADD_COMPARATIVE_CRITERIA_OPTION = 'business-policies-form-add-comparative-criteria-option',
  FORM_CRITERIA_AND_CONNECTOR = 'business-policies-form-criteria-and-connector',
  FORM_CRITERIA_OR_CONNECTOR = 'business-policies-form-criteria-or-connector',
  FORM_DISCOUNT_APPLICATION_RULE_SELECT = 'business-policies-form-discount-application-rule-select',
  FORM_ROLES_SELECT = 'business-policies-form-roles-select',
  FORM_ACTIVATE_ON_STATUS_SELECT = 'business-policies-form-activate-on-status-select',
  FORM_USAGE_LIMIT_INPUT = 'business-policies-form-usage-limit-input',
  FORM_USAGE_LIMIT_PER_CUSTOMER_INPUT = 'business-policies-form-usage-limit-per-customer-input',
  FORM_VOUCHER_TEMPLATE_SECTION = 'business-policies-form-voucher-template-section',
  FORM_VOUCHER_NAME_INPUT = 'business-policies-form-voucher-name-input',
  FORM_VOUCHER_INTEGRATION_CODE_INPUT = 'business-policies-form-voucher-integration-code-input',
  FORM_VOUCHER_DISCOUNT_TYPE_SELECT = 'business-policies-form-voucher-discount-type-select',
  FORM_CUSTOMER_SET_OPERATOR_SELECT = 'business-policies-form-customer-set-operator-select',
  FORM_CUSTOMER_ADD_BUTTON = 'business-policies-form-customer-add-button',
  FORM_CUSTOMER_REMOVE_BUTTON = 'business-policies-form-customer-remove-button',
  FORM_ORDER_CRITERIA_FIELD = 'business-policies-form-order-criteria-field',
  FORM_SUB_CRITERIA_MENU = 'business-policies-form-sub-criteria-menu',
  FORM_REWARD_PAYMENT_METHODS_AUTOCOMPLETE = 'business-policies-form-reward-payment-methods-autocomplete',
  VOUCHER_MENU_TRIGGER = 'business-policies-voucher-menu-trigger',
}
